import { DtoBase } from "../DtoBase";
import { UserDto } from "./UserDto";
import { UserPermissions } from "./UserPermissionsCache";
import { SessionDto } from "../Session/SessionDto";


export enum LogoutResultCode {
	None,
	Succeeded,
	Failed,
	Redirect,
}


export class LogoutResultDto extends DtoBase {

	public Code: LogoutResultCode;
	public RedirectUrl: string;

	constructor(code?: LogoutResultCode) {
		super();

		this.Code = ((code === undefined) ? LogoutResultCode.None : code);
		this.RedirectUrl = "";
	}

	public get HasCode(): boolean {
		return (this.Code !== LogoutResultCode.None);
	}

	public get HasRedirectUrl(): boolean {
		return !!this.RedirectUrl;
	}

	public Write(obj: any, context: any): void {

		obj.logout_result = {};
		obj = obj.logout_result;

		super.Write(obj, context);

		if (this.HasCode) {
			obj.code = LogoutResultCode[this.Code];
		}

		if (this.HasRedirectUrl) {
			obj.redirect_url = this.RedirectUrl;
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.logout_result)
			throw new Error();
		obj = obj.logout_result;

		super.Read(obj, context);

		if (obj.code !== undefined) {
			this.Code = LogoutResultCode[<string>obj.code];
		}

		if (obj.redirect_url !== undefined) {
			this.RedirectUrl = obj.redirect_url;
		}
	}

}